import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FileOpener } from '@ionic-native/file-opener';
import { AssetProvider } from '../../providers/asset/asset';
import { Asset } from '../../interfaces/asset.model';
import { StorageProvider } from '../../providers/storage/storage';
import { FileProvider } from '../../providers/file/file';
import { NavController, AlertController, Platform, ModalController, ToastController } from 'ionic-angular';
import { ViewerAssetPage } from '../../pages/viewer-asset/viewer-asset';
import { AssetFile } from '../../interfaces/asset-file.model';
import { Action } from '../../interfaces/action.model';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthProvider } from '../../providers/auth/auth';
import { HelperProvider } from '../../providers/helper/helper';
import { LocalfileProvider } from '../../providers/localfile/localfile';
import { WebserviceProvider } from '../../providers/webservice/webservice';
import { EmailPackageProvider } from '../../providers/email-package/email-package';
import { EmailPackage } from 'interfaces/email-package.model';
import { EmailPackagePage } from '../../pages/email-package/email-package';
import { AssetType } from 'interfaces/asset-type.model';
import { VisitPackageModalPage, ModalData } from '../../pages/visit-package-modal/visit-package-modal';

@Component({
  selector: 'asset',
  templateUrl: 'asset.html'
})
export class AssetComponent {

  private _isAttachment = false;
  private _asset: Asset;
  assetTypeCode: string;
  @Input() 
  set asset(asset: Asset) {
    this._asset = asset || null;
    this.setAssetTypeCode(asset);
    /*this.setAssetUrl(asset).then((assetPaths: AssetFile) => {
      this._asset.AssetPath = assetPaths.AssetPath;
    });*/
  }
  get asset(): Asset {
    return this._asset;
  }
  @Input() selectMode: boolean;
  @Input() displaylist: boolean;
  @Input()
  set isAttachment(isAttachment: boolean) { this._isAttachment = isAttachment || false; }
  get isAttachment(): boolean { return this._isAttachment; }
  @Output() selectAsset: EventEmitter<Asset> = new EventEmitter();
  @Output() updateFavorite: EventEmitter<boolean> = new EventEmitter();
  @Output() removeAttachment: EventEmitter<Asset> = new EventEmitter();

  assetClass: any;
  thumbnailDirPath: string;
  assetInfos: {assetPath: string, assetZip: string};
  isIosPlatform: boolean;
  

  constructor(
    private plt: Platform,
    public navCtrl: NavController, 
    public modalCtrl: ModalController,
    public assetService: AssetProvider, 
    public storageService: StorageProvider, 
    public fileService: FileProvider,
    public helperService: HelperProvider,
    private fileOpener: FileOpener, 
    public alertCtrl: AlertController, 
    public webservice: WebserviceProvider,
    private toastCtrl: ToastController,
    public translate: TranslateService,  
    public sanitizer: DomSanitizer, 
    public authService: AuthProvider,
    public localfileService: LocalfileProvider,
    public emailPackageService: EmailPackageProvider) {
      // this.isIosPlatform = this.plt.is('ios');
      //[VP - 27/01/2021] Use custom function to detect iOS because of ionic bug: https://github.com/ionic-team/ionic-v3/issues/1104
      this.isIosPlatform = this.helperService.isIOS();
  }

  tapAsset(asset: Asset, event){
    event.stopPropagation();
    if(!this.isAttachment){
      if(!this.selectMode){
        this.showAsset(asset);
      } else {
        this.selectAsset.emit(asset);
      }
    }
  }

  /*setAssetUrl(asset: Asset){
    return this.assetService.getAssetTypeForAsset(asset.AssetTypeId).then((assetType: AssetType) => {
      return this.fileService.getFileAssetUrl(asset.AssetFile, assetType.AssetTypeCode);
    });
  }*/

  showAsset(asset: Asset){
    let toolbarBtnItems: (string|object)[] = ["thumbnails", "search"];

    this.assetService.getAssetTypeForAsset(asset.AssetTypeId).then((assetType: AssetType) => {

      this.fileService.getFileAssetUrl(asset.AssetFile, assetType.AssetTypeCode).then((assetPaths: AssetFile) => {

      this.saveUserOpenAction(asset);
      this.setAssetLastDateOpen(asset);

      asset.AssetPath = assetPaths.AssetPath;
      asset.AssetHTMLPath = assetPaths.AssetHTMLPath;

      if(assetType !== null){
        if(this.isIosPlatform){
          switch (assetType.AssetTypeCode){
            case "PDF":
              this.showPdfAsset(asset, assetPaths.AssetPath, toolbarBtnItems);
            break;
            case "PDF FORM":
              this.showPdfFormAsset(asset, assetPaths.AssetPath, toolbarBtnItems);
            break;
            case "VIDEO":
            case "IMAGE":
            case "HTML":
              this.openAsset(asset, assetPaths, assetType.AssetTypeCode);
            break;
            case "EXTERNAL":
              this.openExternalFile(asset, assetPaths.AssetPath);
            break;
          }
        } else {
          switch (assetType.AssetTypeCode){
            case "HTML":
            case "PDF FORM":
            case "PDF":
            case "EXTERNAL":
              window.open(assetPaths.AssetPath, "_blank", 'fullscreen=yes');
            break;
            case "VIDEO":
            case "IMAGE":
              this.openAsset(asset, assetPaths, assetType.AssetTypeCode);
          }
        }
        return false;
      }
    }).catch(error => {
        console.log(error);
        this.translate.get(['ERROR.ERROR','ERROR.BAD_ASSET']).subscribe(text => {
          let title = text["ERROR.ERROR"];
          let message = text["ERROR.BAD_ASSET"];
          this.displayPopupMessage(title, message);
        });
      });

    })
  }

  showPdfAsset(asset: Asset, assetPath: string, toolbarBtnItems: any[]){
    toolbarBtnItems.push("annotation");
    if(asset.IsSharable) { 
      toolbarBtnItems.push("email", "openIn", "print", {
        title: 'Add to package', 
        image: 'assets/imgs/icons/attach@3x.png',
        action:() =>  {
          PSPDFKit.dismiss(() => {
            this.showEmailPackageModal(asset);
          });
        }
      }); 
    }
    this.openPDFAsset(asset, assetPath, toolbarBtnItems);
  }

  showPdfFormAsset(asset: Asset, assetPath: string, toolbarBtnItems){
    toolbarBtnItems.push("annotation");
    if(asset.IsSharable) {
      toolbarBtnItems.push("email", "openIn", "print", {
        title: 'Save', 
        image: 'assets/imgs/icons/save@3x.png', //VP: according to the doc, it is possible to use an icon for the button, cf https://github.com/PSPDFKit/Cordova-iOS
        action:() =>  {
          this.onTapSaveLocalFile(asset);
        }
      },
      {
        title: 'Add to package', 
        image: 'assets/imgs/icons/attach@3x.png', //VP: according to the doc, it is possible to use an icon for the button, cf https://github.com/PSPDFKit/Cordova-iOS
        action:() =>  {
          PSPDFKit.dismiss(() => {
            this.showEmailPackageModal(asset);
          });
        }
      }
      ); 
    }
    this.openPDFAsset(asset, assetPath, toolbarBtnItems);
  }

  showEmailPackageModal(asset: Asset){
    this.emailPackageService.getPackages().then((emailPackages:EmailPackage[]) => {
      const emailPackageModal = this.modalCtrl.create(VisitPackageModalPage, { asset: asset, emailpackages: emailPackages });
      emailPackageModal.onDidDismiss((data: ModalData) => {
        if(data) {
          if (data.finish) {
            return this.addPackageAndFinish(data, asset);
          }
          else {
            return this.addPackageAndContinue(data, asset);
          } 
        } else {
          this.showAsset(asset);
        }
      });
      emailPackageModal.present();
    });
  }

  addPackageAndFinish(data: ModalData, asset: Asset){
    if(data.isNew){
      this.emailPackageService.createPackage(data, asset.AssetId)
      .then(res => {
        this.helperService.setActivePage(EmailPackagePage);
        this.navCtrl.setRoot(EmailPackagePage, {
          email: data.email
        });
      })
      .catch(err => console.log("error to update storage"))
    } else {
      data.existingPackage.attachments.push(asset.AssetId);
      this.emailPackageService.updatePackage(data.existingPackage)
      .then(res => {
        this.helperService.setActivePage(EmailPackagePage);
        this.navCtrl.setRoot(EmailPackagePage, {
          email: data.existingPackage.email
        });
      })
      .catch(err => console.log("error to update storage"))
    }
  }

  addPackageAndContinue(data: ModalData, asset: Asset){
    if(data.isNew){
      this.emailPackageService.createPackage(data, asset.AssetId)
      .then(res => {
        this.translate.get(['EMAIL_PACKAGE.CREATE_PACKAGE_SUCCESS']).subscribe(text => {
          this.showToast(text["EMAIL_PACKAGE.CREATE_PACKAGE_SUCCESS"]);
        });
      })
      .catch(err => console.log("error to update storage"))
    } else {
      data.existingPackage.attachments.push(asset.AssetId);
      this.emailPackageService.updatePackage(data.existingPackage)
      .then(res => {
        this.translate.get(['EMAIL_PACKAGE.UPDATE_PACKAGE_SUCCESS']).subscribe(text => {
          this.showToast(text["EMAIL_PACKAGE.UPDATE_PACKAGE_SUCCESS"]);
        });
      })
      .catch(err => console.log("error to update storage"))
    }
  }

  setAssetTypeCode(asset: Asset){
    this.assetService.getAssetTypeForAsset(asset.AssetTypeId).then((assetType: AssetType) => {
      this.assetTypeCode = assetType.AssetTypeCode;
      this.setAssetClass();
    });    
  }

  setAssetClass(){
    this.assetClass = "";

    switch(this.assetTypeCode){
      case "PDF":
        this.assetClass = "asset-pdf";
      break;
      case "PDF FORM":
        this.assetClass = "asset-form";
      break;
      case "VIDEO":
        this.assetClass = "asset-video";
      break;
      case "HTML":
        this.assetClass = "asset-html";
      break;
      case "EXTERNAL":
        this.assetClass = "asset-external";
      break;
      case "IMAGE":
        this.assetClass = "asset-image";
      break;
    }
  }

  addAssetInFavorite(asset: Asset, event){
    event.stopPropagation();
    if(asset.IsFavorite){
      this.assetService.removeAssetInFavorite(asset);
      this.updateFavorite.emit(true);
    } else {
      this.assetService.addAssetInFavorite(asset);
    }
  }

  removeAssetFromVisitorPackage(asset: Asset, event){
    event.stopPropagation();
    this.removeAttachment.emit(asset);
  }

  setAssetLastDateOpen(asset: Asset){
    this.assetService.setAssetLastDateOpen(asset);
  }

  saveUserOpenAction(asset){
    if(this.isIosPlatform){
      this.storageService.setUserActions(asset.AssetId, StorageProvider.ACTION_OPEN);
    } else {
      let userAction: Action = {
        AssetId: asset.AssetId,
        Action: StorageProvider.ACTION_OPEN,
        ActionDate: this.helperService.getFullDate(2),
      }
      let arrayUserAction = [userAction];
      this.webservice.setUserActions(arrayUserAction).subscribe(result => {
        console.log("Success send user actions");
      });
    }
  }

  getAssetThumbPath(asset: Asset){
    if(asset.Thumbnail == null) { return false; }
    let safeUrl = this.fileService.getThumbAssetUrl(asset.Thumbnail);
    return this.sanitizer.bypassSecurityTrustResourceUrl(safeUrl);
  }

  getAssetMimeType(fileUrl: string){
    return this.fileService.getFileMimeType(fileUrl);
  }

  getAssetFile(asset: Asset){
    this.authService.ping()
    .subscribe(response => {
      if(response){
        this.downloadAssetFile(asset);
        this.downloadAssetThumbFile(asset);
      } else {
        this.translate.get(['ERROR.INTERNET', 'ERROR.INTERNET_TITLE']).subscribe(text => {
          let title = text["ERROR.INTERNET_TITLE"];
          let message = text["ERROR.INTERNET"];
          this.displayPopupMessage(title, message);
        });
      }
    },
    error => {
      this.translate.get(['ERROR.INTERNET', 'ERROR.INTERNET_TITLE']).subscribe(text => {
        let title = text["ERROR.INTERNET_TITLE"];
        let message = text["ERROR.INTERNET"];
        this.displayPopupMessage(title, message);
      });
    });
  }

  downloadAssetFile(asset: Asset){
    this.assetService.getAssetFile(asset.AssetId)
    .subscribe((response: Blob) => {
      let fileData = response;
      asset.MimeType = fileData.type;
      this.assetService.saveFile(fileData, asset, 'assets')
      .then(res => {
        this.translate.get(['SUCCESS.DOWNLOAD_ASSET_TITLE', 'SUCCESS.DOWNLOAD_ASSET_TEXT']).subscribe(text => {
          this.displayPopupMessage(text["SUCCESS.DOWNLOAD_ASSET_TITLE"], text["SUCCESS.DOWNLOAD_ASSET_TITLE"]);
        });
      });

    }, error => {
      this.translate.get(['ERROR.DOWNLOAD_ASSET_TITLE', 'ERROR.DOWNLOAD_ASSET_TEXT'])
      .subscribe(text => {
        this.displayPopupMessage(text["ERROR.DOWNLOAD_ASSET_TITLE"], text["ERROR.DOWNLOAD_ASSET_TEXT"]);
      });
    });
  }

  downloadAssetThumbFile(asset: Asset){
    this.assetService.getAssetThumbnail(asset)
    .subscribe((response: Blob) => {
      let fileData = response;
      this.assetService.saveFile(fileData, asset, 'thumbnails')
      .then(res => {
        this.translate.get(['SUCCESS.DOWNLOAD_ASSET_TITLE', 'SUCCESS.DOWNLOAD_ASSET_TEXT']).subscribe(text => {
          console.log("Thumbnail: "+text["SUCCESS.DOWNLOAD_ASSET_TITLE"]);
        });
      });
    },
    error => {
      this.translate.get(['ERROR.DOWNLOAD_ASSET_TITLE', 'ERROR.DOWNLOAD_ASSET_TEXT']).subscribe(text => {
        console.log("Thumbnail: "+text["ERROR.DOWNLOAD_ASSET_TEXT"]);
      });
    });
  }

  openPDFAsset(asset: Asset, assetPath: string, toolbarBtnItems){
    let fileName = asset.AssetFile;
    const ext = fileName.substr(fileName.lastIndexOf('.') + 1);
    if(ext.toLowerCase() == 'pdf'){
      if(this.isIosPlatform) {
      this.fileService.readFile(asset.AssetFile, "assets")
      .then(bool => {
        PSPDFKit.present(assetPath, { disableAutomaticSaving: true, pageMode: 'single' });
        PSPDFKit.setRightBarButtonItems(toolbarBtnItems);
      })
      .catch(error => {
        this.showPopupNoAssetFile(asset);
      })
      } else {
        window.open(assetPath, "_blank", 'fullscreen=yes');
      }
    } else {
      this.translate.get(['ERROR.FILE_TYPE_ERROR_TITLE', 'ERROR.FILE_TYPE_ERROR_TEXT']).subscribe(text => {
        this.displayPopupMessage(text["ERROR.FILE_TYPE_ERROR_TITLE"], text["ERROR.FILE_TYPE_ERROR_TEXT"]);
      });
    }
  }

  openAsset(asset: Asset, assetPaths: AssetFile, assetType: string){
    if(this.isIosPlatform){
      this.fileService.readFile(asset.AssetFile, "assets")
      .then(bool => {
        this.navCtrl.push(ViewerAssetPage, {asset: asset, assetPaths: assetPaths, assetType: assetType});
      })
      .catch(error => {
        this.showPopupNoAssetFile(asset);
      })
    } else {
      this.navCtrl.push(ViewerAssetPage, {asset: asset, assetPaths: assetPaths, assetType: assetType});
    }

  }

  openExternalFile(asset: Asset, assetPath: string){
    this.getAssetMimeType(assetPath)
    .then((meta: string) => {
      this.fileOpener.open(assetPath, meta)
      .then(() => console.log('File is opened'))
      .catch(e => console.log('Error opening file', e));
    }, error => {
      console.log(error);
      this.showPopupNoAssetFile(asset);
    });
  }

  showPopupNoAssetFile(asset: Asset){
    this.translate.get(['ERROR.NO_ASSET_FILE_TITLE', 'ERROR.NO_ASSET_FILE_TEXT', 'GENERAL.YES', 'GENERAL.NO']).subscribe(text => {
      const noAssetFilePopup = this.alertCtrl.create({
        title: text["ERROR.NO_ASSET_FILE_TITLE"],
        message: text["ERROR.NO_ASSET_FILE_TEXT"],
        buttons: [
          {
            text: text["GENERAL.NO"],
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: text["GENERAL.YES"],
            handler: data => {
              this.getAssetFile(asset);
            }
          }
        ]
      });
      noAssetFilePopup.present();
    });
  }

  displayPopupMessage(title: string, message: string){
    const popup = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: ['OK']
    });
    popup.present();
  }

  setThumbClass(asset: Asset){
    if(asset.Thumbnail == null) { 
      return false; 
    } else {
        let thumbDisplay = "";
        if(asset.ThumbnailWidth !== null && asset.ThumbnailHeight !== null)
        {
          if (asset.ThumbnailWidth < asset.ThumbnailHeight){
            thumbDisplay = "portrait";
          } else {
            thumbDisplay = "";
          }
        }
        return thumbDisplay;
    }
  }

  onTapSaveLocalFile(asset: Asset){
    //do something
    console.log("SAVE AS!!!");
    this.fileService.getPathToLocalFiles(asset.AssetFile)
    .then((file:any) => {
      let date = new Date();
      let newFile = {
        filePath: file.filePath+this.helperService.getLocalDate(date, 1)+'.pdf',
        fileName: file.fileName+this.helperService.getLocalDate(date, 1)+'.pdf',
        fileDate: this.helperService.getLocalDate(date, 3)
      }
      this.saveLocalFile(newFile, asset);
    })
    .catch(error => {
      console.log("error getPathToLocalFiles: ", error);
    });
  }

  saveLocalFile(newFile: any, asset: Asset){
    PSPDFKit.saveAs(newFile.filePath, result => {

      newFile.filePath = result;

      this.localfileService.createLocalFile(asset, newFile);
  
      PSPDFKit.dismiss(() => {
        this.translate.get(['LOCALFILE.SAVE_TITLE', 'LOCALFILE.SAVE_TEXT', 'GENERAL.YES', 'GENERAL.NO']).subscribe(text => {
          this.displayPopupMessage(text["LOCALFILE.SAVE_TITLE"], text["LOCALFILE.SAVE_TEXT"]);
        });
      });

    });
  }

  async showToast(msg: string) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/asset/asset.ts